import { useDesignBoardCollaboratorsContext } from '../../manage/collaborator-overview/context/DesignBoardCollaboratorsContext';
import BoardActionWithLoginPrompt from '@modules/design-board/component/board-detail/BoardActionWithLoginPrompt';
import { useTracker } from '@archipro-website/tracker';
import { PlusIcon } from 'lucide-react';
import { Button as RoccoButton } from '@archipro/rocco/components/button';

const ShareButton = () => {
    const collaboratorsContext = useDesignBoardCollaboratorsContext();
    const tracker = useTracker();

    const handleClick = () => {
        collaboratorsContext.dispatch({
            type: 'modal-visibility',
            data: {
                visibility: 'visible',
            },
        });
        tracker.log('InviteCollaboratorsReveal', {
            url: new URL(window.location.href),

            data: {
                ElementID:
                    'designboard_detail_header_inviteCollaboratorsReveal',
                Source: 'designBoard, detail',
            },
        });
    };

    return (
        <BoardActionWithLoginPrompt
            action={
                <RoccoButton
                    color="outline"
                    size="default"
                    onClick={handleClick}
                    shape="square"
                    weight="normal"
                    className="hover:bg-black hover:text-white hover:fill-white [&_svg]:hover:text-white"
                >
                    <PlusIcon className="w-4 h-4 mr-2" />
                    SHARE
                </RoccoButton>
            }
        />
    );
};

export default ShareButton;
